import _ from 'lodash';
import { EventEmitter } from 'events';
import assign from 'object-assign';
import AppDispatcher from '../dispatcher/AppDispatcher';
import Constants from '../constants/Constants';

const ActionTypes = Constants.ActionTypes;

const CHANGE_EVENT = 'changeEmoticons';

const _pages = {}; // lapas ar pre-renderētām emoticons
let _currentPage = '1';

let _loading = false;

const EmoticonsStore = assign({}, EventEmitter.prototype, {

  /**
	* Events
	*/

  emitChange() {
    this.emit(CHANGE_EVENT);
  },

  /**
	* @param {function} callback
	*/
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  },

  /**
	* @param {function} callback
	*/
  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },

  /**
	* Add
	*/

  addPage(data, page_id) {
    if (!_pages[page_id]) {
      _pages[page_id] = data;
    }
  },
  getPage(id) {
    if (id) {
      return _pages[id];
    }
    if (typeof _pages[_currentPage] === 'undefined') {
      return false;
    }

    return _pages[_currentPage];
  },

  // visas lapas
  getAll() {
    return _pages;
  },

  setLoading(isLoading) {
    _loading = isLoading;
  },

  isLoading() {
    return _loading;
  },

  setPageId(page_id) {
    _currentPage = page_id;
  },

  getPageId() {
    return _currentPage;
  },
});

EmoticonsStore.dispatchToken = AppDispatcher.register((action) => {
  switch (action.type) {
    case ActionTypes.EMOTICONS_LOAD:
      if (action.loading) {
		  	EmoticonsStore.setLoading(true);
      }
      EmoticonsStore.emitChange();
      break;

    case ActionTypes.EMOTICONS_LOAD_SUCCESS:
      EmoticonsStore.addPage(action.data, action.pageId);
      EmoticonsStore.setLoading(false);
      EmoticonsStore.setPageId(action.pageId);
      EmoticonsStore.emitChange();
      break;
    default:
			// do nothing
  }
});

module.exports = EmoticonsStore;
